import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=19eaa612&"
import script from "./leader.vue?vue&type=script&lang=js&"
export * from "./leader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports